/**
 * ContractType Service
 * Register Angular Services for all things Contract Type
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('ContractType', ['$resource', function($resource){
    return $resource('/api/v3/contractType/:id', null, {
        'update': { method:'PUT' }
    });
}]);
